import Vue from 'vue'
import VueI18n from 'vue-i18n'
import 'url-search-params-polyfill'
var messages = require('./messages')

Vue.use(VueI18n)

let urlParams = new window.URLSearchParams(window.location.search)

let defaultLocale = 'zh'
if (navigator.language.indexOf('en') >= 0) defaultLocale = 'en'
// defaultLocale = 'zh' // DEBUG

let locale = urlParams.get('_locale') || defaultLocale
console.log('Locale', locale)

export const i18n = new VueI18n({
  locale: locale,
  messages
})

if (locale !== 'zh') document.title = i18n.t('page_title')

export default i18n





// WEBPACK FOOTER //
// ./src/i18n/index.js